import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  ReactNode,
} from "react";

interface QuickTourContextValue {
  activeStepKey: string | null;
  setActiveStepKey: (key: string | null) => void;
  // DSH-857: imperative page-tour relaunch. The QuickStartChecklist sets this
  // to a page's tour key; the matching per-page tour wrapper watches it, opens
  // its tour (from step 1), and calls requestTour(null) to consume it. Additive
  // to the pre-existing activeStepKey broadcast — those are untouched.
  requestedTourPage: string | null;
  requestTour: (page: string | null) => void;
}

const QuickTourContext = createContext<QuickTourContextValue>({
  activeStepKey: null,
  setActiveStepKey: () => null,
  requestedTourPage: null,
  requestTour: () => null,
});

export const QuickTourProvider = ({ children }: { children: ReactNode }) => {
  const [activeStepKey, setActiveStepKey] = useState<string | null>(null);
  const [requestedTourPage, setRequestedTourPage] = useState<string | null>(
    null
  );
  const requestTour = useCallback(
    (page: string | null) => setRequestedTourPage(page),
    []
  );
  const value = useMemo(
    () => ({
      activeStepKey,
      setActiveStepKey,
      requestedTourPage,
      requestTour,
    }),
    [activeStepKey, requestedTourPage, requestTour]
  );
  return (
    <QuickTourContext.Provider value={value}>
      {children}
    </QuickTourContext.Provider>
  );
};

export const useQuickTour = () => useContext(QuickTourContext);
